<ng-container >
   <ng-container >
    <app-bread-crumbs [lang]="lang" [routes]="nameRouting"></app-bread-crumbs>
  </ng-container>
  <div class="container mt-4">
    <div class="row categories-collection pb-4 mb-5"  *ngIf="allCategories?.length > 0">
      <div class="p-0" style="cursor: pointer "  *ngFor="let category of allCategories">
        <a
        style="margin: 0px auto !important"
        class="brand-item"
        [routerLink]="['/' + lang + '/products']"
        (click)="rediectToProductPage(category)"
        >
 
        <div class="imgContainer mx-2"
        [ngClass]="{'radius-50 shadow' : categoryTypeData?.isSqure == 'round' }">
            <img  loading="lazy" 
            [ngClass]="{'radius-50 shadow' : categoryTypeData?.isSqure == 'round' }"
                [src]="category.image"
                   [alt]="category?.name"
                class="swiper-lazy"
                onError="this.src='./assets/images/placeholder200.jpg';"
                default="./assets/images/placeholder200.jpg"
                style="
                position: relative;
                top: 0px;
                left: 0px;
                margin-left: 0px;
                margin-right: 0px;
                object-fit: contain;
            "
            />
            <h3 class="text-center product-text my-3" style="color: var(--secoundry-color);">
              {{ lang == "en" ? category.name : category.name_ar }}
            </h3>
        </div>
    </a>
      </div>
    </div>
  </div>


    <ng-container *ngIf="environmentVariables?.ENABLE_CATEGORIES_SECTION">
      <div class="mt-4">
        <app-home-sections [currentPageView]="currentPageViewUrl"></app-home-sections>
      </div>
    </ng-container>
</ng-container>